import React from "react";
import { useLoading } from "./LoadingContext";
import "./Loader.css";

const Loading: React.FC = () => {
  const { loading } = useLoading();

  if (!loading) {
    return null;
  }

  return (
    <div className="loading">
      <svg
        className="ace-of-clubs"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 100 125"
        enableBackground="new 0 0 100 100"
        xmlSpace="preserve"
      >
        <path d="M74.637,41.557c0,0-6.396,0.168-9.54,1.01l-0.224-0.225c0,0,13.691-12.345,1.458-29.516c0,0-13.915-15.825-31.312-1.909  c0,0-11.896,8.867-4.826,25.701c0,0,1.515,3.647,3.928,5.388c0,0,0.45,0.729-0.224,0.729c0,0-19.697-5.106-26.094,11.055  c0,0-7.576,19.192,11.447,27.946c0,0,17.34,7.968,26.094-10.887c0,0,0.842-1.179,1.011-0.279c0.167,0.896,0.896,14.42-8.418,21.716  c0,0-2.301,1.387-1.235,2.468l25.477-0.056c0,0,0.842-0.675-0.169-1.683c-1.009-1.012-9.595-6.565-9.595-22.895  c0,0,0.841-0.59,1.01,0.04c0.167,0.633,4.714,13.26,19.079,13.26c14.367,0,20.763-13.581,20.65-22  C93.043,53.005,84.963,42.119,74.637,41.557z" />
        <text
    x="22"
    y="120"
    
    font-size="12px"
    font-weight="bold"
    font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  >LOADING ...</text>
      
      </svg>
    </div>
  );
};

export default Loading;
